export default "__VITE_ASSET__Mg_6_kZ1__"